import { createClient } from '@connectrpc/connect'
import { createConnectTransport } from '@connectrpc/connect-web'
import { AiChatService } from '../../../../../proto/_gen/aiChat_connect'
import { UpdateClientInfoRequest } from '../../../../../proto/_gen/aiChat_pb'
import { authenticator } from '../../../../pages/_shared/authService'
import { AiChatEvent, AiChatEventPayload } from 'poc-ai-biz-irdb_domain-model'
import { convertClientInfoToProto } from '../../../../../proto/converters'

declare var IRDB_BACKEND_API_URL: string | undefined

type ClientInfo = Extract<AiChatEventPayload, { type: 'clientInfo' }>

export const useUpdateClientInfo = () => {
  const backendApiUrl = IRDB_BACKEND_API_URL
  if (!backendApiUrl) {
    throw new Error('The IRDB_BACKEND_API_URL environment variable is not set')
  }

  const transport = createConnectTransport({
    baseUrl: backendApiUrl,
    interceptors: [authenticator],
  })
  const client = createClient(AiChatService, transport)

  return async (request: { sessionId: string; userId: string; clientInfo: ClientInfo | undefined }) => {
    if (!request.clientInfo) {
      throw new Error('clientInfo is required for updateClientInfo')
    }

    // domain-model型をProtobuf型に変換
    const protoRequest = new UpdateClientInfoRequest({
      sessionId: request.sessionId,
      userId: request.userId,
      clientInfo: convertClientInfoToProto(request.clientInfo),
    })

    const response = await client.updateClientInfo(protoRequest)

    if (response.error) {
      throw new Error(response.error.message || 'Unknown error occurred during client info update')
    }

    if (!response.eventId) {
      throw new Error('No eventId returned from server')
    }

    return {
      eventId: response.eventId,
    }
  }
}
